import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { LoginRequest } from 'api/common/requests'
import { LoginResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import loginData from 'utilities/loginData'
import bpoData from 'utilities/bpoData'

/**
 * ログインAPI
 * @param request
 * @param callback
 */
const loginAPI = async (request: LoginRequest, callback: (status: Status, nextScene: string | null) => void) => {
  await apiClient
    .post('/login', request)
    .then(async (response: AxiosResponse<LoginResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      if (status === Status.Success) {
        await loginData.setResponse(response.data)
        
        // 審査中情報がある場合は保存
        if (response.data.pendingVerification) {
          const pending = response.data.pendingVerification
          
          // BPOデータをセッションストレージに保存
          bpoData.setItem('trustdock_verification_id', pending.verificationId)
          bpoData.setBpoRequestId(pending.requestId)
          if (pending.bpoVerificationId) {
            bpoData.setItem('bpo_verification_id', pending.bpoVerificationId)
          }
          bpoData.setItem('bpo_created_at', new Date().toISOString())
          
          // BPO審査画面へ遷移
          callback(status, '/bpo/processing')
          return
        }
      }
      callback(status, loginData.getLoggedInScene())
    })
    .catch((error) => {
      console.error(error)
    })
}

export default loginAPI
